import { memo } from 'react';
import PropTypes from 'prop-types';
import {
  PiListBold,
  PiTextIndentBold,
  PiTextOutdentBold,
} from 'react-icons/pi';

import { cn } from '#/lib/utils';
import AccountMenu from '#/modules/infra/layout/AccountMenu';
import ThemeToggle from '#/modules/infra/layout/ThemeToggle';

const Nav = ({
  isDesktop,
  toggleExpanded,
  setToggleExpand,
  mobileAsideOpen,
  setMobileAsideOpen,
}) => (
  <header className="sticky top-0 z-[var(--z-nav)] shrink-0 bg-panel shadow-sm">
    <div className="flex items-center justify-between gap-2.5 px-5 py-2.5">
      <div className="flex items-center justify-center">
        {isDesktop ? (
          <div className="flex items-center">
            <PiTextOutdentBold
              className={cn('cursor-pointer', toggleExpanded && 'hidden')}
              size={28}
              onClick={() => setToggleExpand(true)}
              aria-label="收合側欄"
            />
            <PiTextIndentBold
              className={cn('cursor-pointer', !toggleExpanded && 'hidden')}
              size={28}
              onClick={() => setToggleExpand(false)}
              aria-label="展開側欄"
            />
          </div>
        ) : (
          <button
            type="button"
            className="cursor-pointer"
            aria-label="開啟選單"
            aria-expanded={mobileAsideOpen}
            onClick={() => setMobileAsideOpen(true)}
          >
            <PiListBold size={28} aria-hidden />
          </button>
        )}
      </div>

      <div className="flex items-center gap-2">
        <ThemeToggle />
        <AccountMenu />
      </div>
    </div>
  </header>
);

Nav.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.bool.isRequired,
  setToggleExpand: PropTypes.func.isRequired,
  mobileAsideOpen: PropTypes.bool.isRequired,
  setMobileAsideOpen: PropTypes.func.isRequired,
};

export default memo(Nav);
